import { NativeInterface } from './NativeInterface'

const DEFAULT_CATEGORY = 'all'
const DEFAULT_APP_NAME = 'lls'
const APP_MARKETING_VERSION = '1.0'
const TRACK_URL = 'https://flm3.llsapp.com/data_collect'

class Track {
  constructor (config) {
    this.query = this.queryString(location.search)
    this.isInApp = !!this.query.appId
    this.category = config.category || DEFAULT_CATEGORY
    this.app_name = config.appName || DEFAULT_APP_NAME
    this.app_version = config.appVersion || APP_MARKETING_VERSION
    this.basic_params = config.basicParams || {}
  }
  makeRandomIdStr (strLen) {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let text = ''
    for (let i = 0; i < strLen; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return text
  }
  getSessionId () {
    let sessionId = window.sessionStorage.getItem('sessionId')
    if (!sessionId) {
      sessionId = Math.floor(Date.now() / 1000) + '.' + this.makeRandomIdStr(6)
      window.sessionStorage.setItem('sessionId', sessionId)
    }
    return sessionId
  }
  getTempUserId () {
    return 'tmp' + this.getSessionId()
  }
  buildTrackPackage (trackData) {
    const commonData = {
      platform: this.category,
      session_id: this.getSessionId(),
      app_marketing_version: this.app_version
    }
    trackData.time = this._formatedTimeNow()
    return {
      user_id: this.getTempUserId(),
      app_name: this.app_name,
      common_data: commonData,
      batch_data: [{
        event_type: 22,
        payload: trackData
      }]
    }
  }
  _zeroFill (num, targetLength) {
    const absNum = Math.abs(num).toString()
    const zerosToFill = targetLength - absNum.length
    return Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNum
  }
  _formatedTimeNow () {
    const t = new Date()
    const year = t.getFullYear()
    const month = this._zeroFill(t.getMonth() + 1, 2)
    const day = this._zeroFill(t.getDate(), 2)
    const hour = this._zeroFill(t.getHours(), 2)
    const minutes = this._zeroFill(t.getMinutes(), 2)
    const seconds = this._zeroFill(t.getSeconds(), 2)
    return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`
  }
  normalizeTrackpayload (params) {
    const normalizedPayload = {}
    for (let key in params) {
      normalizedPayload[this._dasherize(key)] = params[key]
    }
    return normalizedPayload
  }
  _dasherize (str) {
    return /[A-Z]/g.test(str) ? str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase() : str
  }
  queryString (text) {
    const query = {}
    if (text) {
      const params = text.substring(1).split('&')
      params.forEach(item => {
        const kv = item.split('=')
        query[kv[0]] = decodeURIComponent(kv[1])
      })
    }
    return query
  }
  xhr (options) {
    const request = new XMLHttpRequest()
    request.open(options.type, options.url, true)
    request.setRequestHeader('Content-Type', options.contentType)
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        if (typeof options.success === 'function') {
          options.success()
        }
      } else {
        if (typeof options.error === 'function') {
          options.error()
        }
      }
    }
    request.send(options.data)
  }
  send (params, success) {
    const trackData = this.normalizeTrackpayload(params)
    const trackPackage = this.buildTrackPackage(trackData)
    this.xhr({
      url: TRACK_URL,
      data: JSON.stringify(trackPackage),
      type: 'POST',
      contentType: 'application/json',
      success: success || function () {}
    })
  }
  sendPageTrackWeb (params = {}, success) {
    params = this._assign(this.basic_params, {
      action: 'page_view',
      ...params
    })
    this.extendSourceTypeParams(params)
    this.extendAbTestParams(params)
    this.send(params, success)
  }
  sendActionTrackWeb (params = {}, success) {
    params = this._assign(this.basic_params, params)
    this.extendSourceTypeParams(params)
    this.extendAbTestParams(params)
    this.send(params, success)
  }
  sendPageTrackNative (pageName, category = this.category, params = {}, afterTrack) {
    params = this._assign(this.basic_params, {
      pageName,
      category,
      ...params
    })
    this.extendSourceTypeParams(params)
    this.extendAbTestParams(params)
    NativeInterface.invoke('doPage', () => {
      if (typeof afterTrack === 'function') {
        afterTrack()
      }
    }, JSON.stringify(params))
  }
  sendActionTrackNative (actionName, params = {}, afterTrack) {
    params = this._assign(this.basic_params, {
      action: actionName,
      channel: this.query.channel || '',
      ...params
    })
    this.extendSourceTypeParams(params)
    this.extendAbTestParams(params)
    NativeInterface.invoke('doAction', () => {
      if (typeof afterTrack === 'function') {
        afterTrack()
      }
    }, JSON.stringify(params))
  }
  sendPageTrack (pageName, params = {}, afterTrack) {
    const category = params.category || this.category
    if (this.isInApp) {
      this.sendPageTrackNative(pageName, category, params, afterTrack)
    } else {
      this.sendPageTrackWeb({
        pageName,
        category,
        ...params
      }, afterTrack)
    }
  }
  sendActionTrack (pageName, actionName, params = {}, afterTrack) {
    if (this.isInApp) {
      this.sendActionTrackNative(actionName, params, afterTrack)
    } else {
      this.sendActionTrackWeb({
        pageName: pageName,
        action: actionName,
        ...params
      }, afterTrack)
    }
  }
  sendTrack (type = 'page', actionOrPageName, success) {
    if (type === 'page') {
      this.sendPageTrack({
        pageName: actionOrPageName
      }, success)
    } else {
      this.sendActionTrack({
        action: actionOrPageName
      }, success)
    }
  }
  extendSourceTypeParams (params) {
    const orderSourceType = this.query.orderSourceType
    if (orderSourceType) {
      params.source_type = orderSourceType
    }
  }
  extendAbTestParams (params) {
    const { abExpId, abVersion } = this.query
    if (abExpId && abVersion) {
      params.expData = { abExpId, abVersion }
    }
  }
  _assign (orgin, target) {
    return {
      ...target,
      ...orgin
    }
  }
}

export default {
  install (Vue, options = {}) {
    Vue.prototype.$track = new Track(options)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/Track.js